/**
 * MIØ: Ergänzt die Cookie-Einstellungen von Shopify um die Dienste je
 * Kategorie und einen Link zur Datenschutzerklärung. Shopify beschreibt die
 * Kategorien nur allgemein; Besucher sollen sehen, was sie ein- oder
 * ausschalten (Betreiberwunsch 29.09.2026). Gestaltung in assets/mio-cookie.css.
 *
 * Die Liste muss zu Abschnitt 10 der Datenschutzerklärung passen
 * (shopify/rechtstexte/datenschutz.html). Kommt ein Dienst dazu oder fällt
 * weg, beide Stellen ändern.
 */

const TEXTE = {
  de: {
    dienste: 'Dienste',
    essential: 'Shopify – Warenkorb, Kasse, Sicherheit und deine Cookie-Auswahl',
    preferences: 'Shopify – z. B. zuletzt angesehene Produkte, Sprache und Land',
    marketing: 'Instagram und Facebook (Meta-Pixel), TikTok-Pixel, Google Ads',
    analytics: 'Google Analytics 4, Shopify-Statistik',
    mehr: 'Mehr dazu in der',
    datenschutz: 'Datenschutzerklärung',
  },
  en: {
    dienste: 'Services',
    essential: 'Shopify – cart, checkout, security and your cookie choice',
    preferences: 'Shopify – e.g. recently viewed products, language and country',
    marketing: 'Instagram and Facebook (Meta Pixel), TikTok Pixel, Google Ads',
    analytics: 'Google Analytics 4, Shopify analytics',
    mehr: 'More in our',
    datenschutz: 'privacy policy',
  },
};

const sprache = document.documentElement.lang?.toLowerCase().startsWith('en') ? 'en' : 'de';
const t = TEXTE[sprache];
const DATENSCHUTZ_URL = `${window.Shopify?.routes?.root ?? '/'}pages/datenschutz`;

function ergaenzen(dialog) {
  if (dialog.dataset.mioErgaenzt) return;
  dialog.dataset.mioErgaenzt = '1';

  for (const kategorie of ['essential', 'preferences', 'marketing', 'analytics']) {
    const option = dialog.querySelector(`#shopify-pc__prefs__${kategorie}`);
    if (!option) continue;
    const zeile = document.createElement('p');
    zeile.className = 'mio-pc-dienste';
    const titel = document.createElement('strong');
    titel.textContent = t.dienste;
    zeile.append(titel, t[kategorie]);
    option.append(zeile);
  }

  const intro = dialog.querySelector('.shopify-pc__prefs__intro-main');
  if (intro) {
    const hinweis = document.createElement('p');
    const link = document.createElement('a');
    link.href = DATENSCHUTZ_URL;
    link.textContent = t.datenschutz;
    hinweis.append(`${t.mehr} `, link, '.');
    intro.append(hinweis);
  }
}

// Shopify baut den Dialog erst beim Öffnen auf.
const beobachter = new MutationObserver(() => {
  const dialog = document.getElementById('shopify-pc__prefs__dialog');
  if (dialog) ergaenzen(dialog);
});
beobachter.observe(document.body, { childList: true, subtree: true });
